<template>
    <div class="mt-3 flex items-center text-sm text-gray-500 font-medium sm:mr-6 sm:mt-0 capitalize">
        <a href="#" @click.prevent="handleSwitchLang('fr')" :class="'mx-2 ' + (locale === 'fr' ? 'text-blue-600' : '')">FR</a>
        <a href="#" @click.prevent="handleSwitchLang('en')" :class="'mx-2 ' + (locale === 'en' ? 'text-blue-600' : '')">EN</a>
    </div>
</template>

<script>
export default {
    props: {
        item: Object,
    },
    computed: {
        locale() {
            return this.$store.state.config.locale;
        },
    },
    methods: {
        handleSwitchLang(lang) {
            this.$store.dispatch('config/setLocale', lang);
            const current = this.$route;
            const params = Object.assign({}, current.params, { locale: lang });
            if (current.name) {
                this.$router.push({ name: current.name, params, query: current.query });
            } else {
                this.$router.push({ path: `/${lang}` });
            }
        },
    }
}
</script>
